import React from 'react';
import classes from './Work.module.css';

const workHistory = [
    {
        startDate: 'September 2024',
        endDate: 'Present',
        jobTitle: 'Operations Support',
        company: 'Engineering Trainer',
        description:
            <ul>
                <li>Took care of tech related tasks and back-end maintenance</li>
                <li>Created marketing materials and edited product videos</li>
            </ul>
    },
    {
        startDate: 'July 2023',
        endDate: 'November 2023',
        jobTitle: 'Systems Software Engineer Intern',
        company: 'Electronic Arts',
        description:
            <ul>
                <li>Worked on core engine integration and performance optimizations based on computer hardware</li>
                <li>Contributed to software performance analysis tools and general purpose libraries</li>
            </ul>
    },
    {
        startDate: 'August 2022',
        endDate: 'November 2022',
        jobTitle: 'Software Engineer',
        company: 'Privacy Systems',
        description:
            <ul>
                <li>Worked on developing a virtual cloud data storage solution in Python</li>
                <li>Wrote tests, benchmarks and user verification tools for various components used in the product</li>
                <li>Tested integration with Python and Java Amazon S3 SDKs</li>
            </ul>
    },
    {
        startDate: 'September 2021',
        endDate: 'September 2022',
        jobTitle: 'Programming Instructor',
        company: 'EdulogiQ',
        description:
            <ul>
                <li>Taught programming to children of various ages through video game development</li>
                <li>Wrote assessments and feedback for the students</li>
            </ul>
    },
];

const deepCopy = (obj) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(deepCopy);
    }
    const copiedObj = {};
    for (const key in obj) {
        copiedObj[key] = deepCopy(obj[key]);
    }
    return copiedObj;
};

function Work() {
    const modifiedWorkHistory = deepCopy(workHistory);

    const parseDate = (dateStr) => {
        if (dateStr === 'Present') return new Date();
        const [month, year] = dateStr.split(' ');
        return new Date(`${month} 1, ${year}`);
    };

    const overlaps = [];
    for (let i = 0; i < modifiedWorkHistory.length - 1; i++) {
        const currentStartDate = parseDate(modifiedWorkHistory[i].startDate);
        const nextEndDate = parseDate(modifiedWorkHistory[i + 1].endDate);

        if (currentStartDate < nextEndDate) {
            const tempDate = modifiedWorkHistory[i].startDate;
            modifiedWorkHistory[i].startDate = modifiedWorkHistory[i + 1].endDate;
            modifiedWorkHistory[i + 1].endDate = tempDate;
            overlaps.push(i);
        }
    }

    return (
        <div className={classes.timelineWrapper}>
            <div className={classes.timeline}>
                {modifiedWorkHistory.map((work, index) => {
                    const isOverlap = overlaps.includes(index);
                    const itemClass = isOverlap
                        ? `${classes.timelineItem} ${classes.overlap}`
                        : classes.timelineItem;
                    return (
                        <div className={itemClass} key={index}>
                            <div className={classes.timelineDate}>
                                <div className={classes.endDate}>{work.endDate}</div>
                                <div className={classes.startDate}>{work.startDate}</div>
                            </div>
                            <div className={classes.timelineContent}>
                                <h3>{work.jobTitle}</h3>
                                <h4>{work.company}</h4>
                                <div>{work.description}</div>
                            </div>
                            {isOverlap && (
                                <div className={classes.timelineGap}></div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Work;
